import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';

import usePageTitle from '@/hooks/usePageTitle';
export default function ResetPassword() {
  usePageTitle('Reset password');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const { updatePassword } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await updatePassword(password);
      toast.success('Password updated.');
      nav('/dashboard', { replace: true });
    } catch (err) {
      toast.error(err.message || 'Could not update password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-hero-soft text-foreground flex items-center justify-center p-6">
      <Card className="w-full max-w-md rounded-2xl border-border/70">
        <CardContent className="p-6 sm:p-8 space-y-5">
          <div>
            <div className="font-display text-2xl font-semibold">Set a new password</div>
            <div className="text-sm text-muted-foreground mt-1">Keep it kind to your future self.</div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="password">New password</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="rounded-xl" />
            </div>
            <Button type="submit" className="w-full rounded-xl" disabled={busy} data-testid="reset-submit-button">
              {busy ? 'Updating…' : 'Update password'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
